import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslatePipe } from '@ngx-translate/core';
import {
  QualificationTrainings,
  QualificationTrainingsStatus,
  RoleAction,
  RolePermissionSubject,
} from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { map, Observable, Subject, takeUntil, tap } from 'rxjs';
import { TrainingQualificationsV2ListService } from '../../../service/training-qualifications-v2-list.service';
import { TrainingQualificationsFinalizeDrawerService } from '../training-qualifications-finalize-drawer/training-qualifications-finalize-drawer.service';

@Component({
  selector: 'wilson-training-qualification-finalize-trigger',
  imports: [CommonModule, TranslatePipe, NzButtonModule, NzTooltipModule],
  templateUrl: './training-qualification-finalize-trigger.component.html',
  styleUrl: './training-qualification-finalize-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingQualificationFinalizeTriggerComponent
  implements OnInit, OnDestroy
{
  private readonly trainingQualificationsV2ListService = inject(
    TrainingQualificationsV2ListService,
  );
  private readonly trainingQualificationsFinalizeDrawerService = inject(
    TrainingQualificationsFinalizeDrawerService,
  );

  private destroyed$ = new Subject<void>();

  @Output() refresh = new EventEmitter<number>();

  public can = inject(AbilityServiceSignal).can;
  public readonly RoleAction = RoleAction;
  public readonly RolePermissionSubject = RolePermissionSubject;

  protected finalizableQualificationTrainings$: Observable<
    QualificationTrainings[]
  > =
    this.trainingQualificationsV2ListService.selectedQualificationTrainings$.pipe(
      map((qualificationTrainings) => {
        return this.getFinalizableTrainings(qualificationTrainings);
      }),
      tap((finalizableTrainings) => {
        this.trainingQualificationsFinalizeDrawerService.setTrainingsToFinalize(
          finalizableTrainings,
        );
      }),
    );
  protected selectedQualificationsTrainings$ =
    this.trainingQualificationsV2ListService.selectedQualificationTrainings$;
  protected loading$ =
    this.trainingQualificationsFinalizeDrawerService.loading$;

  ngOnInit(): void {
    this.trainingQualificationsFinalizeDrawerService.successfullyFinalizedTrainings$
      .pipe(
        takeUntil(this.destroyed$),
        tap(() => {
          this.refresh.emit(new Date().getTime());
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private getFinalizableTrainings(
    qualificationTrainings: QualificationTrainings[],
  ): QualificationTrainings[] {
    return qualificationTrainings.filter((qualificationTraining) => {
      return (
        qualificationTraining.status ===
        QualificationTrainingsStatus.resultAccepted
      );
    });
  }

  protected showTrainingQualificationFinalizeDrawer(): void {
    this.trainingQualificationsFinalizeDrawerService.setFinalizeDrawerVisible(
      true,
    );
  }
}
